"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MetaMaskWallet = void 0;
var react_1 = __importDefault(require("react"));
var react_loader_spinner_1 = __importDefault(require("react-loader-spinner"));
var AddCeloNetworkButton_1 = require("../components/AddCeloNetworkButton");
var connectors_1 = require("../connectors");
var useMetaMaskConnector_1 = require("../connectors/useMetaMaskConnector");
var MetaMaskWallet = function (_a) {
    var onSubmit = _a.onSubmit;
    var _b = useMetaMaskConnector_1.useMetaMaskConnector(onSubmit), error = _b.error, dapp = _b.dapp, network = _b.network;
    if ((error === null || error === void 0 ? void 0 : error.name) === connectors_1.UnsupportedChainIdError.NAME) {
        return (react_1.default.createElement("div", { className: "tw-space-y-6" },
            react_1.default.createElement("p", { className: "tw-text-xl font-medium dark:tw-text-gray-300" }, "Switch to the Celo Network"),
            react_1.default.createElement("p", { className: "dark:tw-text-gray-400" },
                "In order to use ",
                dapp.name,
                " you must be connected to the Celo network.",
                ' ',
                react_1.default.createElement("a", { className: "tw-underline tw-font-medium", target: "_blank", rel: "noreferrer", href: "https://docs.celo.org/getting-started/wallets/using-metamask-with-celo" }, "What does this mean?")),
            react_1.default.createElement("div", { className: "tw-flex tw-justify-center" },
                react_1.default.createElement(AddCeloNetworkButton_1.AddCeloNetworkButton, { chainId: network.chainId }))));
    }
    return (react_1.default.createElement("div", { className: "tw-flex tw-items-center tw-justify-center" }, error ? (react_1.default.createElement("p", { className: "tw-text-red-500 tw-pb-4" }, error.message)) : (react_1.default.createElement("div", { className: "tw-my-8 tw-flex tw-items-center tw-justify-center" },
        react_1.default.createElement(react_loader_spinner_1.default, { type: "TailSpin", color: "#666666", height: "60px", width: "60px" })))));
};
exports.MetaMaskWallet = MetaMaskWallet;
//# sourceMappingURL=metamask.js.map